'use es6';

export const INVALID_SERVERLESS_FILE = 'INVALID_SERVERLESS_FILE';
export const FILENAME_CONTAINS_INVALID_CHAR = 'FILENAME_CONTAINS_INVALID_CHAR';